import { useEffect, useRef } from 'react';
import { useGlobalEvents } from './use-global-events';

export const useEvent = (eventName, callback) => {
  const eventData = useRef(
    false
  );

  const clearEvent = () => {
    if (eventData.current) {
      removeEventHook(eventData.current.eventName, eventData.current.hookId);
      eventData.current = false;
    }
  };

  const { addEventHook, removeEventHook } = useGlobalEvents();
  useEffect(() => {
    clearEvent();

    const hookId = addEventHook(eventName, callback);
    eventData.current = {
      eventName,
      hookId,
    };

    return () => {
      clearEvent();
    };
  }, [eventName, callback]);
};
